<div class="ui-tooltip-content" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <ng-content />
</div>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="outsideClick()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="setPositionStrategy"
>
  <div [ngClass]="[noPadding ? 'ui-tooltip-wrapper-no-padding' : 'ui-tooltip-wrapper', noBorder ? 'ui-tooltip-wrapper--no-border' : '']">
    <ng-container *ngIf="hasEmbeddedView; else plainText">
      <ng-template *ngTemplateOutlet="template" />
    </ng-container>
    <ng-template #plainText>
      {{ text }}
    </ng-template>
  </div>
</ng-template>
